import { DefaultOptionType } from 'rc-select/lib/Select';
import { Dispatch, SetStateAction } from 'react';
import { GroupDescriptionType } from '@atlas-frontend/sdk';

export type InputDataVersionType = 'active' | 'draft' | 'output';

export interface InputDataDescriptionInfo {
  description?: GroupDescriptionType;
  descriptionOptions: DefaultOptionType[];
  setDescription: Dispatch<SetStateAction<GroupDescriptionType | undefined>>;
}

export interface InputDataVersionInfo {
  setVersion: Dispatch<SetStateAction<InputDataVersionType | undefined>>;
  version?: InputDataVersionType;
  versionOptions: DefaultOptionType[];
}

export type EditMode = 'edit' | 'view';

export enum SubmittedDataStatus {
  DATA = 'DATA',
  IMPUTED_DATA = 'IMPUTED_DATA',
  EMPTY = 'EMPTY',
}
